import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NavParams } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-izin-preview',
  templateUrl: './izin-preview.component.html',
  styleUrls: ['./izin-preview.component.scss'],
})
export class IzinPreviewComponent implements OnInit {

  load: boolean = false;
  saving: any = {};
  idData: any;

  detData: any = {};
  det: any;
  tampilData: boolean = false;
 
  cabang: any = '';
  grup: any = '';
  nama: any = '';
  nip: any = '';
  jabatan: any = '';
  phone: any = '';
  email: any = '';
  username: any = '';
  password: any = '';

  usertype: any = '';

  selct: any = '';


  disabledInput: boolean = false;
  detList: any;

  id: any;
  ids: any;

  form: any;

  path: any;
  sourcePath: string = '';
  safePath?: SafeResourceUrl;
  isPdfPreview: boolean = false;
  isPreviewLoading: boolean = true;
  previewFailed: boolean = false;
  private loadTimeoutId: any;
  photoKtpPemohon: any;
  loadktpPemohon: boolean = false;
  photoKtpPemohonx: any;
  imageUrl?: string;

  constructor(
    public api: ApiService,
    public util: UtilService,
    public navParams: NavParams,
    public dom: DomSanitizer,

  ) {
    this.id = this.navParams.data.id;
    this.sourcePath = String(this.id || '');
    this.path = this.sourcePath;
    this.initPreview();
   }

  ngOnInit() {
      // this.detailData()
  }

  ngOnDestroy(): void {
    if (this.loadTimeoutId) {
      clearTimeout(this.loadTimeoutId);
    }
  }

  initPreview(withCacheBust: boolean = false) {
    this.previewFailed = false;
    this.isPreviewLoading = true;

    const targetPath = withCacheBust ? this.withCacheBuster(this.sourcePath) : this.sourcePath;
    this.path = targetPath;
    this.isPdfPreview = this.isPdfFile(targetPath);

    if (this.isPdfPreview) {
      this.safePath = this.dom.bypassSecurityTrustResourceUrl(targetPath);
      this.startLoadTimeout();
    }
  }

  private startLoadTimeout() {
    if (this.loadTimeoutId) {
      clearTimeout(this.loadTimeoutId);
    }
    this.loadTimeoutId = setTimeout(() => {
      if (this.isPreviewLoading) {
        this.previewFailed = true;
        this.isPreviewLoading = false;
      }
    }, 12000);
  }

  onPreviewLoad() {
    this.isPreviewLoading = false;
    this.previewFailed = false;
    if (this.loadTimeoutId) {
      clearTimeout(this.loadTimeoutId);
    }
  }

  onPreviewError() {
    this.isPreviewLoading = false;
    this.previewFailed = true;
    if (this.loadTimeoutId) {
      clearTimeout(this.loadTimeoutId);
    }
  }

  retryPreview() {
    this.initPreview(true);
  }

  openInNewTab() {
    if (!this.path) {
      return;
    }
    window.open(this.path, '_blank', 'noopener,noreferrer');
  }

  downloadFile() {
    if (!this.path) {
      return;
    }
    const anchor = document.createElement('a');
    anchor.href = this.path;
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.download = this.extractFileName(this.path);
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  private extractFileName(url: string): string {
    try {
      const cleanUrl = String(url).split('?')[0].split('#')[0];
      const chunks = cleanUrl.split('/');
      const fileName = chunks[chunks.length - 1];
      return fileName || 'lampiran';
    } catch {
      return 'lampiran';
    }
  }

  private withCacheBuster(url: string): string {
    if (!url) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${Date.now()}`;
  }

  private isPdfFile(filePath: string): boolean {
    if (!filePath) {
      return false;
    }
    const cleanPath = String(filePath).split('?')[0].split('#')[0].toLowerCase();
    return cleanPath.endsWith('.pdf');
  }

  pilih(p) {
    console.log(p);
    if (this.selct == '') {
      this.selct = p;
    } else if (this.selct == p) {
      // this.selct = '';
    } else {
      this.selct = p;
    }
    console.log('selct', this.selct);
  }

  detailData(){
    this.api.get('data/master/kolektor')
      .subscribe((data) => {
        this.detData = data;
        if (this.detData.error == 0) {
          this.detList = this.detData.data;
          setTimeout(() => {
            this.load = false;
            }, 1000);
        } else {
          this.load = false;
          this.util.showToast(this.detData.message, 'success', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  async transform(src: string) {
    this.load = true;
    var that = this;
    this.api.photo(src)
      .then((response) => response.blob())
      .then((imageBlob) => {
        const reader = new FileReader();
        this.load = false;
        reader.onloadend = () => {
          console.log('load image with fetch');
          that.photoKtpPemohonx = reader.result;
          that.path = this.dom.bypassSecurityTrustUrl(that.photoKtpPemohonx) as string;
          console.log('url im', that.path)
        };
        reader.readAsDataURL(imageBlob);
      });
  }

  save(){
    this.load = true;
    var arrayData = [this.id];
    if(this.ids == ''){
      this.form = {
        contract_id: arrayData,
        assign_to: this.selct,
      };
    }else{
      this.form = {
        contract_id: JSON.parse(this.ids),
        assign_to: this.selct,
      };
    }
    this.api.post('backoffice/kolektor/penagihan/assignto', this.form)
      .subscribe((data) => {
        this.saving = data;
        if (this.saving.error == 0) {
          this.load = false;
          this.util.showToast(this.saving.message, 'success', 'bottom');
          this.api.dismissData('','confirm');
        } else {
          this.load = false;
          this.util.showToast(this.saving.message, 'danger', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  handleSelection(selectedValue: string, model: any) {
    if (model == 'cabang') {
      this.cabang = selectedValue;
    } else if (model == 'usertype') {
      this.usertype = selectedValue;
    } 
  }

  dismiss() {
    this.api.dismiss()
  }
}
